module.exports = __webpack_public_path__ + "frontend/images/white/carousel/traveling.png?bfe304aa8becdcc53fe999794f895539";